import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProfessorDashboard from '../components/dashboard/ProfessorDashboard';
import StudentDashboard from '../components/dashboard/StudentDashboard';
import LoadingSpinner from '../components/common/LoadingSpinner';
import '../styles/Dashboard.css';

const Dashboard: React.FC = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 사용자 정보가 로드되면 로딩 상태 해제
    if (!loading && user) {
      // user 객체가 존재하고 로딩이 완료된 경우에만 로딩 상태 해제
      setIsLoading(false);

      // 어드민 사용자인 경우 어드민 페이지로 리다이렉트
      const userRole = user?.role || '';
      if (userRole.toUpperCase() === 'ADMIN') {
        navigate('/admin');
      }
    } else if (!loading && !user) {
      // 로딩은 완료되었지만 사용자 정보가 없는 경우 로그인 페이지로 리다이렉트
      navigate('/login');
    }
  }, [loading, user, navigate]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // 로딩 중이거나 사용자 정보가 없으면 로딩 스피너 표시
  if (isLoading || !user) {
    return <LoadingSpinner />;
  }

  // 역할 검사
  const userRole = user?.role || '';
  const isProfessor = userRole.toUpperCase() === 'PROFESSOR';

  return (
    <div className="dashboard-container">
      {/* 상단 헤더 */}
      <header className="dashboard-header">
        <div className="header-logo">ClassTrans</div>
        <div className="header-user">
          <span>{user?.school} {user?.username} 님</span>
          <button onClick={handleLogout} className="logout-button">Logout</button>
        </div>
      </header>

      <div className="dashboard-content">
        {/* 사용자 역할에 따라 다른 대시보드 렌더링 */}
        {isProfessor ? <ProfessorDashboard user={user} /> : <StudentDashboard user={user} />}
      </div>
    </div>
  );
};

export default Dashboard;
